module.exports = __webpack_public_path__ + "assets/img/block-hover-b885de18.png";